var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, computed } from "mobx";
import getSingletonStore from "./getSingletonStore";
export class BodyFixedStore {
    constructor() {
        this.top = 0;
        this.isFixed = false;
        this.stopScroll = () => {
            if (this.isFixed) {
                return;
            }
            this.isFixed = true;
            this.top = window.scrollY;
            document.body.style.top = `-${this.top}px`;
            document.body.setAttribute("class", "overflowHide");
            document.body.style.overflow = "hidden";
        };
        this.revertScroll = () => {
            document.body.removeAttribute("class");
            document.body.style.top = "0";
            window.scrollTo(0, this.top);
            this.top = 0;
            this.isFixed = false;
            document.body.style.overflow = "scroll";
        };
        window.addEventListener("popstate", () => {
            document.body.removeAttribute("class");
            document.body.style.top = "0";
            this.top = 0;
            this.isFixed = false;
        });
    }
    get scrollTop() {
        return this.top;
    }
}
__decorate([
    observable
], BodyFixedStore.prototype, "top", void 0);
__decorate([
    observable
], BodyFixedStore.prototype, "isFixed", void 0);
__decorate([
    computed
], BodyFixedStore.prototype, "scrollTop", null);
__decorate([
    action.bound
], BodyFixedStore.prototype, "stopScroll", void 0);
__decorate([
    action.bound
], BodyFixedStore.prototype, "revertScroll", void 0);
export const getStore = getSingletonStore(BodyFixedStore);
